interface EmptyStateProps {
  type: 'no-categories' | 'no-results' | 'error';
  onClearSearch?: () => void;
  onRetry?: () => void;
}

const EmptyState = ({ type, onClearSearch, onRetry }: EmptyStateProps) => {
  if (type === 'error') {
    return (
      <div className="flex flex-col items-center justify-center py-20 px-4">
        <div className="w-32 h-32 bg-red-50 rounded-full flex items-center justify-center mb-6">
          <i className="ri-alert-line text-6xl text-red-500"></i>
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900 mb-3 text-center">
          Failed to load categories
        </h2>
        
        <p className="text-gray-600 text-center max-w-md mb-8">
          Please try again later or contact support if the problem persists.
        </p>
        
        {onRetry && (
          <button
            onClick={onRetry}
            className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
          >
            <i className="ri-refresh-line"></i>
            Retry
          </button>
        )}
      </div>
    );
  }

  if (type === 'no-categories') {
    return (
      <div className="flex flex-col items-center justify-center py-20 px-4">
        <div className="w-32 h-32 bg-gray-100 rounded-full flex items-center justify-center mb-6">
          <i className="ri-folder-3-line text-6xl text-gray-400"></i>
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900 mb-3 text-center">
          No categories available
        </h2>
        
        <p className="text-gray-600 text-center max-w-md mb-8">
          We are still setting up product categories. Please check back later.
        </p>
      </div>
    );
  }

  // no-results
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4">
      <div className="w-32 h-32 bg-gray-100 rounded-full flex items-center justify-center mb-6">
        <i className="ri-search-line text-6xl text-gray-400"></i>
      </div>
      
      <h2 className="text-2xl font-bold text-gray-900 mb-3 text-center">
        No categories match your search
      </h2>
      
      <p className="text-gray-600 text-center max-w-md mb-8">
        Try adjusting your search keywords or clearing filters to find what you're looking for.
      </p>
      
      {onClearSearch && (
        <button
          onClick={onClearSearch}
          className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
        >
          <i className="ri-close-circle-line"></i>
          Clear Search
        </button>
      )}
    </div>
  );
};

export default EmptyState;
